import $ from 'jquery';
import PhotoSwipe from 'photoswipe';
import PhotoSwipeUI from 'photoswipe/dist/photoswipe-ui-default';
import GalleryTemplate from '../Templates/PhotoSwipeGallery.html';
import CursorTemplate from '../Templates/Cursor.html';

/** Internal dependencies */
import { NCST } from '../';
import ImageLightbox from '../Support/ImageLightbox';
import VideoLightbox from '../Support/VideoLightbox';

export default class LightboxController {
	constructor() {
		this.thumbnails = [];

		this.activeLightbox;

		this.types = {
			default: new ImageLightbox(),
			video: new VideoLightbox(),
		};

		this.elements = {
			$pswpElement: null,
			$follower: null,
		};
	}

	init() {
		var self = this;

		self.thumbnails = self.findThumbnails();

		// If there are no linked thumbnails, nothing to do.
		if ( self.thumbnails.length == 0 ) {
			return;
		}

		// Add class to identify thumbnail images for follower cursor
		self.thumbnails.find( 'img' ).addClass( 'pswp__thumbnail' );

		// Insert UI markup
		NCST.elements.$body.append( GalleryTemplate );
		NCST.elements.$body.append( CursorTemplate );
		self.elements.$pswpElement = $( '.pswp' );
		self.elements.$follower = $( '.follower' );

		// Setup event listener for zoom indicator
		NCST.elements.$doc.on( 'mousemove', function ( event ) {
			if (
				NCST.features.mouseUsed &&
				( $( event.target ).hasClass( 'pswp__thumbnail' ) ||
					$( event.target ).hasClass( 'pswp__img' ) )
			) {
				self.elements.$follower.css( {
					display: 'block',
					left: event.clientX + 'px',
					top: event.clientY + 'px',
				} );
			} else {
				self.elements.$follower.hide();
			}
		} );

		// Init the different types
		$.each( self.types, ( type, lightboxType ) => {
			lightboxType.init();
		} );

		// Set up listeners for thumbnail link clicks
		self.thumbnails.click( function ( event ) {
			var $link = $( this ), // <a> tag
				lightbox = self.getLightboxType(
					$link.data( 'ncst-lightbox' )
				);

			event.preventDefault();

			lightbox.setLightbox(
				$link,
				self.openPhotoSwipe(
					lightbox.getItems( $link ),
					lightbox.getOptions( $link )
				)
			);
		} );
	}

	/**
	 * Returns the object responsible for handling lightboxes of the given type.
	 *
	 * @param  {string} type The type of lightbox object to return.
	 * @return {obj}         The lightbox object for the given type.
	 */
	getLightboxType( type ) {
		if ( type && this.types.hasOwnProperty( type ) ) {
			return this.types[ type ];
		}

		return this.types[ 'default' ];
	}

	/**
	 * Triggers each registered type of lightbox to retrieve its own thumbnails.
	 * The results are merged into a single jQuery object and returned.
	 *
	 * @return {jQuery obj} The thumbnail matches for all lightbox types.
	 */
	findThumbnails() {
		var thumbMatches = [];

		$.each( this.types, ( key, lightboxType ) => {
			thumbMatches.push( lightboxType.getThumbs() );
		} );

		return thumbMatches.reduce( ( accumulator, value ) => {
			return accumulator.add( value );
		}, $() );
	}

	/**
	 * Opens PhotoSwipe with the given items and options. Handles adding and removal of
	 * custom cursor.
	 *
	 * @param  {Array} items    An array of PhotoSwipe items.
	 * @param  {obj}   options  PhotoSwipe options.
	 */
	openPhotoSwipe( items, options ) {
		var $follower;

		$follower = this.elements.$follower;
		$follower.addClass( 'is-minus' );

		this.activeLightbox = new PhotoSwipe(
			this.elements.$pswpElement.get( 0 ),
			PhotoSwipeUI,
			items,
			options
		);

		$( '#ncstate-utility-bar' ).hide();

		this.activeLightbox.init();

		this.activeLightbox.listen( 'close', function () {
			$follower.removeClass( 'is-minus' );
			$( '#ncstate-utility-bar' ).show();
		} );

		return this.activeLightbox;
	}
}
